import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from 'ng2-translate';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../core/auth.service';
import { ConfigService } from '../../core/config.service';
import { StyleUtils } from '../../utils/style-utils';
import { DialogType } from '../domain/enums/dialog-type';
import { Address, DialogProperties } from '../domain/models';
import { NavigationService } from './services/navigation.service';
import {
    CloseErrorDialog, LoadSectors, SetFeatureThreshold, ToggleMap, ShowUpdatePopup, ClosePopup, SetSearchData, SetInSearchMode
} from './store/distribution.actions';
import {
    getDistributionDetail, getLoading, getLoadingError, getMapExpanded, getMapExtent, getMapSize,
    getSectorFeatures, getFilteredSectorIds, tooManyFeatures, getDeviceFeatures, getAddressFeatures,
    getStreetFeatures, getEventFeatures, getInSearchMode, getPopupData, getFilteredAddresses
} from './store/distribution.reducer';
import { DistributionState } from './store/distribution.state';
import { DistributionViewModel } from './view-models/distribution.view-model';
import * as _ from 'lodash';
import Feature from 'ol/Feature';
import { PopupData } from '../../../../libs/map/components/update-popup/popup-data';
import { SearchData } from '../../../../libs/map/components/search-popup/search-data';

@Component({
    selector: 'app-distribution',
    templateUrl: './distribution.component.html',
    styleUrls: ['./distribution.component.scss']
})
export class DistributionComponent implements OnInit {

    appUrl: string;
    appCode: string;
    appId: string;

    detailView$: Observable<DistributionViewModel>;
    isDetailView: boolean;

    loadingData$: Observable<boolean>;
    loadingData: boolean;
    loadingError$: Observable<boolean>;
    loadingError: boolean;

    mapExpanded$: Observable<boolean>;
    mapExpanded: boolean;
    mapExtent$: Observable<number[]>;
    mapSize$: Observable<string>;
    mapSize: string;

    polygonFeatures$: Observable<Feature[]>;
    trackingFeatures$: Observable<Feature[]>;
    addressFeatures$: Observable<Feature[]>;
    streetFeatures$: Observable<Feature[]>;
    eventFeatures$: Observable<Feature[]>;
    tooManyFeatures$: Observable<boolean>;
    filteredSectorIds$: Observable<string[]>;
    filteredSectorIds: string[];
    filteredAddresses$: Observable<Address[]>;
    inSearchMode$: Observable<boolean>;
    popupData$: Observable<PopupData>;
    featureStyler: Function;
    trackingStyler: Function;
    addressStyler: Function;
    streetStyler: Function;

    username: string;
    loadingDialog: DialogProperties;
    loadingErrorDialog: DialogProperties;

    constructor(
        private authService: AuthService,
        private config: ConfigService,
        private navigation: NavigationService,
        private store: Store<DistributionState>,
        private translate: TranslateService,
        private toastr: ToastrService
    ) {
        this.detailView$ = store.pipe(select(getDistributionDetail));
        this.loadingData$ = store.pipe(select(getLoading));
        this.loadingError$ = store.pipe(select(getLoadingError));
        this.mapExpanded$ = store.pipe(select(getMapExpanded));
        this.mapExtent$ = store.pipe(select(getMapExtent));
        this.mapSize$ = store.pipe(select(getMapSize));
        this.inSearchMode$ = store.pipe(select(getInSearchMode));
        this.popupData$ = store.pipe(select(getPopupData));
        this.filteredAddresses$ = store.pipe(select(getFilteredAddresses));
        this.polygonFeatures$ = store.pipe(select(getSectorFeatures)).map((features: Feature[]) => {
            return _.flatten(features);
        });
        this.trackingFeatures$ = store.pipe(select(getDeviceFeatures)).map((features: Feature[]) => {
            return _.flatten(features);
        });
        this.streetFeatures$ = store.pipe(select(getStreetFeatures));
        this.eventFeatures$ = store.pipe(select(getEventFeatures));
        this.addressFeatures$ = store.pipe(select(getAddressFeatures));
        this.tooManyFeatures$ = store.pipe(select(tooManyFeatures));
        this.filteredSectorIds$ = store.pipe(select(getFilteredSectorIds));
    }

    ngOnInit(): void {
        this.navigation.init();
        this.store.dispatch(new SetFeatureThreshold(parseInt(this.config.getEnv('polygonsRenderingThreshold'), 10)));
        this.tooManyFeatures$.subscribe((tooMany: boolean) => {
            if (tooMany) {
                this.toastr.info(this.translate.instant('TOO_MANY_FEATURES', { value: this.config.getEnv('polygonsRenderingThreshold') }));
            }
        });
        this.detailView$.subscribe((detailView: DistributionViewModel) => {
            this.isDetailView = detailView != null;
        });
        this.filteredSectorIds$.subscribe((filteredSectorIds: string[]) => {
            this.filteredSectorIds = filteredSectorIds;
        });
        this.mapExpanded$.subscribe((mapExpanded: boolean) => {
            this.mapExpanded = mapExpanded;
        });
        this.appUrl = `https://${this.config.getEnv('mapHost')}/bgis/wms`;
        this.appCode = this.config.getEnv('mapPassword');
        this.appId = this.config.getEnv('mapLogin');
        this.featureStyler = StyleUtils.getProgressStyle;
        this.trackingStyler = StyleUtils.getEventStyle;
        this.addressStyler = StyleUtils.getAddressStyle;
        this.streetStyler = StyleUtils.getProgressStyle;
        this.username = this.authService.getUsername();
        this.loadingDialog = new DialogProperties({
            type: DialogType.LoadingDialog,
            title: 'LOADING_DATA'
        });
        this.loadingErrorDialog = new DialogProperties({
            type: DialogType.ErrorDialog,
            title: 'DATA_REQUEST_ERROR'
        });
    }

    onCloseDialog(): void {
        this.store.dispatch(new CloseErrorDialog());
    }

    onLogOut(): void {
        this.authService.logout();
    }

    onResizeMapClick(): void {
        this.store.dispatch(new ToggleMap());
        if (this.mapExpanded && !this.isDetailView) {
            this.store.dispatch(new LoadSectors(this.filteredSectorIds));
        }
    }
    public onShowPopup(ids: string[]): void {
        this.store.dispatch(new ShowUpdatePopup(ids));
    }
    public closePopup(): void {
        this.store.dispatch(new ClosePopup(false));
    }
    public onSubmitSearchData(data: SearchData): void {
        this.store.dispatch(new SetSearchData(data));
    }
    public closeSearchPopup(): void {
        this.store.dispatch(new SetInSearchMode(false));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/distribution.component.ts